import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const onePasswordConnectServer = defineConnector({
  identifier: "onePasswordConnectServer",
  name: "1Password Connect Server",
  tagLine: "Self-hosted secrets automation for 1Password",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Deploy a 1Password Connect server",
      items: [
        {
          kind: "markdown",
          content:
            "Create a [Secrets Automation workflow](https://start.1password.com/developer-tools/infrastructure-secrets/connect), grant it access to the vaults you want to use, and save the access token. Then deploy a [1Password Connect server](https://developer.1password.com/docs/connect/get-started#step-2-deploy-a-1password-connect-server) using the credentials file from the workflow.",
        },
      ],
    },
    {
      title: "Enter your Connect server details",
      items: [
        {
          kind: "baseUrl",
          label: "API address",
          required: true,
          placeholder: "https://connect.example.com:8080",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText:
            "The base URL of your Connect server, including the port.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
          helperText: "The access token created with your Connect server.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/v1/vaults`,
  },
});
